module.exports = __webpack_public_path__ + "img/card_down.8fa4a55c.png";